import React from 'react';
import { FormControl, InputLabel, OutlinedInput, FormHelperText, Box } from '@mui/material';

/**
 * FormTextArea - Unpacked composition to bypass TextField wrapper bugs
 */
const FormTextArea = React.forwardRef((props, ref) => {
  const {
    name,
    label,
    value,
    onChange,
    onBlur,
    onFocus,
    placeholder = '',
    required = false,
    disabled = false,
    error = false,
    helperText={helperText},
    rows = 4,
    maxLength,
    className,
    sx = {},
    ...rest
  } = props;

  return (
    <Box ref={ref} sx={{ width: '100%', mt: 1, ...sx }}>
      <FormControl 
        fullWidth 
        error={error} 
        disabled={disabled} 
        required={required}
        variant="outlined"
      >
        {/* 1. Explicitly standalone label forced to shrink */}
        <InputLabel shrink htmlFor={`textarea-${name}`}>
          {label}
        </InputLabel>

        {/* 2. Explicitly standalone input */}
        <OutlinedInput
          id={`textarea-${name}`}
          name={name}
          value={value ?? ''}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          placeholder={placeholder}
          multiline
          minRows={rows}
          // The label prop here doesn't render text, it tells the border exactly how wide to cut the notch
          label={label} 
          notched={true}
          inputProps={{
            maxLength: maxLength,
          }}
          sx={{
            '& textarea': {
              fontFamily: 'inherit',
              resize: 'none',
              lineHeight: 1.5,
            }
          }}
          className={className}
          {...rest}
        />
        
        {/* 3. Explicitly standalone helper text */}
        {(error || helperText) && (
          <FormHelperText>{error ? helperText : ''}</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
});

FormTextArea.displayName = 'FormTextArea';

export default FormTextArea;